/**
 * @fileoverview used to create a supabase client, should not be modified
 */
import { createClient } from "@supabase/supabase-js";
import useAuthStore from "./store/useAuthStore";

const supabaseUrl = `${process.env.REACT_APP_SUPABASE_URL}`;
const supabaseAnonKey = `${process.env.REACT_APP_SUPABASE_ANON}`;

// Default client for unauthenticated access
const supabaseClient = createClient(supabaseUrl, supabaseAnonKey);
export default supabaseClient;

export const getAuthenticatedClient = () => {
  const token = useAuthStore.getState().getAccessToken();

  if (!token) return null;
  return createClient(supabaseUrl, supabaseAnonKey, {
    global: {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  });
};

// NOTE: Admin operations should use Edge Functions instead of direct admin client
// The service_role key has been removed from the frontend for security.
// Use Edge Functions (e.g., check-user-exists) for admin operations.
